// extracted by mini-css-extract-plugin
var _1 = "checked__duWOV";
var _2 = "switcher__ea_ti";
var _3 = "switcherWrapper__lejhA";
var _4 = "thumb__bIpnU";
export { _1 as "checked", _2 as "switcher", _3 as "switcherWrapper", _4 as "thumb" }
export default { "checked": _1, "switcher": _2, "switcherWrapper": _3, "thumb": _4 }
